import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { isFunction, noop } from 'lodash';
import { INDICATION_TYPES, removeIndication } from '../modules/taboola-common-frontend-modules/Indications';
import { useNavigate } from './useNavigate';

export const useHandleModuleNavigation = ({ path, gtmCallback = noop }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleNavigation = useCallback(
        cancelFunc => {
            gtmCallback();
            if (isFunction(cancelFunc)) {
                cancelFunc();
            }

            dispatch(removeIndication({ type: INDICATION_TYPES.ERROR }));
            navigate(path, { state: { skipFetchReport: true } });
        },
        [dispatch, gtmCallback, path, navigate]
    );

    return handleNavigation;
};
